import { Link } from "react-router-dom";
import { Heart, Ticket } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { PageHero, SectionHead } from "@/components/site/Shared";
import { SponsorPackages } from "@/components/site/Offerings";

export default function Support() {
  const { settings: s } = useSite() || {};
  return (
    <div data-testid="support-page">
      <PageHero testid="support-hero" eyebrow="support opportunities" title="Put your name behind the verse"
        intro="Sponsor a workshop, underwrite the whole program, bring Def Street to life — or simply grab a festival ticket. Every option keeps our programs free."
        image={s?.images?.impact}>
        <Link to="/donate" className="btn-terra" data-testid="support-donate-button"><Heart className="w-4 h-4" /> Donate any amount</Link>
        <Link to="/def-street#tickets" className="btn-line" data-testid="support-tickets-button"><Ticket className="w-4 h-4" /> Festival tickets</Link>
      </PageHero>
      <section className="container-mas py-16 sm:py-20">
        <SectionHead eyebrow="sponsorships" title="Sponsor a workshop, the program, or Def Street" className="mb-10" />
        <SponsorPackages />
      </section>
      <section className="bg-tea text-shell">
        <div className="container-mas py-14 grid md:grid-cols-2 gap-8 items-center">
          <h2 className="h-section !text-3xl sm:!text-4xl">Prefer to give monthly? Small, steady gifts keep the lights on.</h2>
          <div className="flex md:justify-end"><Link to="/donate" className="btn-terra" data-testid="support-monthly-button">Start a monthly gift</Link></div>
        </div>
      </section>
    </div>
  );
}
